module.exports = __webpack_public_path__ + "static/img/address.e38faa2e.png";